exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TrainingLayout-module__wrapper___1IHL_{display:grid;width:100%;gap:1.5rem}@media screen and (min-width:1024px){.TrainingLayout-module__wrapper___1IHL_{grid-template-columns:1fr auto;justify-content:start;max-width:964px}}.TrainingLayout-module__wrapper___1IHL_ .TrainingLayout-module__content___3YIA8{grid-row:2}@media screen and (min-width:1024px){.TrainingLayout-module__wrapper___1IHL_ .TrainingLayout-module__content___3YIA8{grid-row:initial}}.TrainingLayout-module__wrapper___1IHL_ .TrainingLayout-module__menu___RaJpJ{grid-row:1;align-self:start;width:100%;min-width:264px}@media screen and (min-width:1024px){.TrainingLayout-module__wrapper___1IHL_ .TrainingLayout-module__menu___RaJpJ{grid-row:initial;position:sticky;top:40px;right:0}}", ""]);

// exports
exports.locals = {
	"wrapper": "TrainingLayout-module__wrapper___1IHL_",
	"content": "TrainingLayout-module__content___3YIA8",
	"menu": "TrainingLayout-module__menu___RaJpJ"
};